import Vue from './app.js';

export default {
  create(context, shared, sharedBy) {
    Vue.http.post(
      'api/reporting/new',
      {
        client: context.client,
        utilisateur: context.utilisateur,
        entite: context.entite,
        date: context.dateStart,
        datefin: context.dateEnd,
        temps: Number(context.heures) + Number(context.min),
        hatvp: context.hatvp,
        action_categorie: context.action_categorie,
        action_type: context.action_type,
        action_commentaire: context.action_commentaire,
        action_theme: context.action_theme,
        decision_publique: context.decision_publique,
        decideur_publique_categorie: context.decideur_publique_categorie,
        decideur_publique_fonction: context.decideur_publique_fonction,
        shared: shared,
        sharedBy: sharedBy,

        // SUPPRIMES
        // decideur_publique_nom: context.decideur_publique_nom,
        // action_position_defendue: context.action_position_defendue,

        //NOUVEAU CHAMPS :
        domaine_interventions: context.domaine_interventions,
        action_type_hatvp: context.action_type_hatvp,

        //recurrence :
        recurring: context.recurring,
        recurring_starts_at: context.recurring_starts_at,
        recurring_frequency: context.recurring_frequency,
        recurring_unit: context.recurring_unit,
        recurring_detail: context.recurring_detail,
      }
    ).then(response => {
      context.response = response.data;
      if (context.response.error) {
        context.showError();
      }
      else {
        context.reporting(context.client);
        context.showSuccessCreate();
      }
    })
  },
  share(context, iduser_sharedBy, idclient){
    Vue.http.post(
      'api/reporting/share',
      {
        id: context.id,
        user_id_notification: context.user_id_notification,
        iduser_sharedBy: iduser_sharedBy,
        idclient: idclient,
      }
    )
  },
  update(context) {
    console.log('domaine_intervention',context.domaine_interventions);
    Vue.http.post(
      'api/reporting/update',
      {
        id: context.id,
        client: context.client,
        utilisateur: context.utilisateur,
        entite: context.entite,
        date: context.dateStart,
        datefin: context.dateEnd,
        temps: Number(context.heures) + Number(context.min),
        hatvp: context.hatvp,
        action_categorie: context.action_categorie,
        action_type: context.action_type,
        action_commentaire: context.action_commentaire,
        action_theme: context.action_theme,
        decision_publique: context.decision_publique,
        decideur_publique_categorie: context.decideur_publique_categorie,
        decideur_publique_fonction: context.decideur_publique_fonction,

        // SUPPRIMES
        // action_position_defendue: context.action_position_defendue,
        // decideur_publique_nom: context.decideur_publique_nom,

        //NOUVEAU CHAMPS :
        domaine_interventions: context.domaine_interventions,
        action_type_hatvp: context.action_type_hatvp,

        //recurrence :
        recurring: context.recurring,
        recurring_starts_at: context.recurring_starts_at,
        recurring_frequency: context.recurring_frequency,
        recurring_unit: context.recurring_unit,
        recurring_detail: context.recurring_detail,
      }
    ).then(response => {
      context.response = response.data;
      if (context.response.error) {
        context.showError();
      }
      else {
        context.reporting(context.client);
        context.showSuccessUpdate();
      }
    });
  },
  destroy(context, id, iduser_deletedBy, idclient) {
    Vue.http.post(
      'api/reporting/delete',
      {
        id:id,
        iduser_deletedBy: iduser_deletedBy,
        idclient: idclient
      }
    ).then(response => {
      console.log(response)
      context.reporting(context.client);
    })
  },
  show(context, id, typeShow, current_user_id){
    Vue.http.post(
      'api/reporting/show',
      {
        id:id,
      }
    ).then(response => {
      console.log('data-to-show',response.data.data.recurring);
      context.infoEntree = response.data.data;
      // context.utilisateur = response.data.data.utilisateur.iduser;
      if( response.data.data.entite ) {
        context.entite = response.data.data.entite.id;
      }
      context.action_categorie = response.data.data.action_categorie.id;
      context.action_type = response.data.data.action_type.id;
      context.action_theme = response.data.data.action_theme;
      context.action_commentaire = response.data.data.action_commentaire;
      context.decideur_publique_categorie = response.data.data.decideur_publique_categorie;
      context.decision_publique = response.data.data.decision_publique;
      context.decideur_publique_fonction = response.data.data.decideur_publique_fonction;
      context.date[0] = response.data.data.date;
      context.date[1] = response.data.data.datefin;
      context.hatvp = response.data.data.hatvp;
      context.client = response.data.data.idclient;
      context.heures = Math.floor(response.data.data.temps);
      if(typeShow == 'sharedReporting'){
        context.utilisateur = current_user_id;
      }else{
        context.utilisateur = response.data.data.utilisateur.iduser;
      }
      context.min = response.data.data.temps - Math.floor(response.data.data.temps);

      // SUPPRIMES
      // context.action_position_defendue = response.data.data.action_position_defendue;
      // context.decideur_publique_nom = response.data.data.decideur_publique_nom;

      // NOUVEAUX:

      context.domaine_interventions = response.data.data.domaine_interventions;
      context.action_type_hatvp= response.data.data.action_type_hatvp;

      //recurring
      context.recurring = 0;
      if(response.data.data.recurring) {
        let recurring = response.data.data.recurring[0];
        context.recurring = 1;
        context.recurring_starts_at = recurring.next_run_day; // à changer pour last_run_day

        //missing
        context.recurring_unit = recurring.unit;
        context.recurring_frequency = recurring.rec_freq;

        // doit être remplis en dernier!
        context.recurring_detail = recurring.frequency_rule;

      }
    })
  },
  search(context,query){
    Vue.http.post(
      'api/reporting/search',
      {
        query: query,
      }
    ).then(response => {
      context.results = response.data.data;
      context.searchDone = true;
    }).then(response =>{
      $('body').removeClass('loading')
    })
  }
}



// WEBPACK FOOTER //
// ./assets/js/reporting.js